import React from "react";

interface SidebarHintOverlayProps {
  visible: boolean;
}

export default function SidebarHintOverlay({ visible }: SidebarHintOverlayProps) {
  if (!visible) return null;

  return (
    <div className="desktop-sidebar-hints" aria-hidden="true">
      <span>[D] Dashboard</span>
      <span>[S] Sales</span>
      <span>[P] Purchase</span>
      <span>[R] Products</span>
      <span>[C] Customers</span>
      <span>[T] Reports</span>
    </div>
  );
}
